// extracted by mini-css-extract-plugin
export default {"danger":"#dc3545"};